/* eslint-disable camelcase */
import React, { useState } from 'react';
import {
  MONGODB_EDITIONS,
  VALIDATION,
} from 'constant';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';
import { _t } from 'utils';
import { getMongoDBRoleOptions } from 'utils/database';

export default ({
  cluster, onSubmit, fieldOptions, editItem,
}) => {
  const clusterId = cluster.id;
  let initModel = {};
  if (editItem) {
    initModel = fieldOptions ? fieldOptions.reduce((acc, key) => {
      acc[key] = editItem.properties[key];
      return acc;
    }, {}) : editItem.properties;
  }
  const [model, setModel] = useState(initModel);
  const [currentRole, setCurrentRole] = useState({});

  const isEnterpriseCluster = cluster?.properties?.edition === MONGODB_EDITIONS.ENTERPRISE;
  const roleOptions = getMongoDBRoleOptions(isEnterpriseCluster);

  const getRoleOption = (role) => roleOptions.find((item) => item.value === role);
  const currentRoleOption = getRoleOption(currentRole.role);

  let fields = [
    {
      name: 'username',
      type: 'text',
      title: _t('DATABASES.FORM_FIELDS.USERNAME.TITLE'),
    },
    {
      name: 'password',
      type: 'password',
      title: _t('DATABASES.FORM_FIELDS.PASSWORD.TITLE'),
    },
    {
      name: 'roles',
      editable: false,
      type: 'array',
      icon: 'boxes',
      title: _t('DATABASES.FORM_FIELDS.ROLES.TITLE'),
      actionButtonName: _t('DATABASES.FORM_FIELDS.ROLES.ACTION_BUTTON'),
      setItemTitle: (role) => `${role.role} - ${role.database}`,
      onChange: () => setCurrentRole({}),
      fields: [
        {
          name: 'role',
          type: 'dropdown',
          onChange: (e) => setCurrentRole((role) => ({ ...role, role: e })),
          options: roleOptions.map((e) => (e.value)),
          title: _t('DATABASES.FORM_FIELDS.ROLES.TITLE'),
        },
        {
          name: 'database',
          onChange: (e) => setCurrentRole((role) => ({ ...role, database: e })),
          type: 'text',
          title: _t('DATABASES.FORM_FIELDS.DATABASE.TITLE'),
        },
      ],
    },
  ];

  if (fieldOptions) {
    fields = fields.filter((field) => fieldOptions.includes(field.name));
  }

  const validations = [
    { name: 'username', type: VALIDATION.REQUIRED },
    {
      name: 'username',
      type: VALIDATION.REGEX,
      regex: /^[0-9a-zA-Z]{3,256}$/,
      message: _t('COMMON.VALIDATION_TEXTS.LATIN_NUMBER_VALIDATION'),
    },
    // {
    //   name: 'password',
    //   type: VALIDATION.REGEX,
    //   regex: /^[0-9a-zA-Z]{8,50}$/,
    //   message: _t('COMMON.VALIDATION_TEXTS.PASSWORD_LATIN_NUMBER_VALIDATION'),
    // },
    {
      name: 'password',
      type: VALIDATION.STRING,
      min: 10,
      max: 50,
    },
    {
      name: 'roles',
      type: VALIDATION.ARRAY,
      min: 1,
    },
  ];

  if (!editItem) {
    validations.push({ name: 'password', type: VALIDATION.REQUIRED });
  }

  const submitHandler = (values) => {
    values.roles = !values.roles ? [] : values.roles.map((role) => {
      role.database = role.database || getRoleOption(role.role)?.defaultDatabase;
      return role;
    });

    if (editItem) {
      if (values.password === '') {
        delete values.password;
      }
      actions.database.mongodb.updateMongoDBUser({
        clusterId,
        username: editItem.properties.username,
        properties: values,
      }).then((e) => {
        if (onSubmit) onSubmit(e);
      });
    } else {
      actions.database.mongodb.createMongoDBUser({ clusterId, properties: values }).then((e) => {
        if (onSubmit) onSubmit(e);
      });
    }
  };

  const onCancel = () => {
    onSubmit();
  };

  const changeFields = [{
    name: 'database',
    props: {
      disabled: !!currentRoleOption?.disable,
      value: currentRoleOption?.defaultDatabase || currentRole.database || '',
    },
  },
  {
    name: 'role',
    props: {
      options: roleOptions
        .filter((roleOption) => !roleOption.defaultDatabase || !model.roles?.find((modelRole) => modelRole.role === roleOption.value))
        .map((e) => (e.value)),
    },
  },
  {
    name: 'roles',
    props: {
      validations: [
        { name: 'role', type: VALIDATION.REQUIRED },
        ...(currentRoleOption?.disable ? [] : [{ name: 'database', type: VALIDATION.REQUIRED }]),
      ],
    },
  }];

  return (
    <Shared.forms.Form
      fields={fields}
      onChange={(values) => {
        const roles = values.roles?.map((item) => ({ ...item, database: getRoleOption(item.role)?.defaultDatabase || item.database })) || [];
        setModel({ ...values, roles });
      }}
      fieldsValues={model}
      onProps={model}
      validations={validations}
      onSubmit={submitHandler}
      isCancel={!!editItem}
      onCancel={onCancel}
      changeFields={changeFields}
      validateOnBlur
    />
  );
};
